module.exports = __webpack_public_path__ + "static/media/Co occurring DisordersActive.0af1507f.svg";